import React, { useEffect, useMemo, useRef, useState } from "react";
import { Input, Layout, Flex, Avatar, Button, Dropdown, Badge } from "antd";
import { MessageIcon, NotificationIcon } from "../../../assets/svg";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import logo from "../../../../src/assets/images/logo.png";
import { colors } from "../../../constants/colors";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { appConfig } from "../../../constants/config/appConfig";
import { appAssetsConfig } from "../../../constants/config/appAssetsConfig";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllNotifications,
  markAsRead,
} from "../../../redux/services/common/commonServices";
import dayjs from "dayjs";
import { userRoles } from "../../../constants";
import { useTranslation } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";
import styles from "./Navbar.module.scss";
import {
  dateObjToDispViewDate,
  timeObjToDispViewTimeWithSuffix,
} from "../../../utils/utils";
import { useNavigate } from "react-router-dom";
import { navigateToScreen } from "./notificationUtil";

const Navbar = ({ setDrawerOpen }) => {
  /* local storage dependencies */
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  /* local storage dependencies */

  const { t } = useTranslation("notificationType");

  const notificationCount = useSelector(
    (state) => state.common.notificationCount
  );

  const notificationsList = useSelector((state) => state.common.notifications);

  const dispatch = useDispatch();

  const handleNotificationRead = (notification) => {
    let dataToBeSent = {
      notification_ids: [notification?._id],
    };
    dispatch(markAsRead(dataToBeSent));
  };

  const navigate = useNavigate();

  const renderNotification = (notification) => {
    return (
      <div
        className={styles.notificationContainer}
        onMouseEnter={() =>
          notification.read_at === null && handleNotificationRead(notification)
        }
        onClick={() =>
          navigateToScreen(navigate, notification?.event_type, userSession)
        }
      >
        <div className={styles.badgeContainer}>
          {notification.read_at === null && <Badge status="error" />}
        </div>
        <div className={styles.notificationContent}>
          <div className={styles.notificationTitle}>
            {t(notification.event_type)}
          </div>
          <div className={styles.notificationDescription}>
            {notification.notification_text}
          </div>
          <div className={styles.notificationDate}>
            {/* {dayjs(notification?.created_at).format("DD/MM/YYYY")} */}
            <p>{`${dateObjToDispViewDate(
              notification?.created_at,
              "ddmmyyyy"
            )} - ${timeObjToDispViewTimeWithSuffix(
              dayjs
                .utc(notification?.created_at)
                .local()
                .tz(dayjs.tz.guess())
                .format("YYYY-MM-DDTHH:mm:ss")
            )}`}</p>
          </div>
        </div>
      </div>
    );
  };

  const items = useMemo(() => {
    return notificationsList && notificationsList.length > 0
      ? notificationsList?.map((item) => ({
          ...item,
          key: item._id,
          label: renderNotification(item),
        }))
      : [
          {
            key: 1,
            label: (
              <span className={styles.noNotifcation}>
                {t("noNotificaiton")}
              </span>
            ),
          },
        ];
  }, [notificationsList]);

  const notificationTimer = useRef();

  useEffect(() => {
    if (
      userSession &&
      Object.keys(userSession).length !== 0 &&
      userSession !== null &&
      userSession !== undefined
    ) {
      const messageInterval = () => {
        notificationTimer.current = setInterval(() => {
          dispatch(getAllNotifications());
        }, 30000);
      };
      messageInterval();
    }

    return () => {
      clearInterval(notificationTimer.current);
    };
  }, [userSession]);

  useEffect(() => {
    userSession &&
      Object.keys(userSession).length !== 0 &&
      userSession !== null &&
      userSession !== undefined &&
      dispatch(getAllNotifications());
  }, [userSession]);

  return (
    <Layout.Header className={styles.headerContainer}>
      <Flex gap="1rem">
        <div className={styles.logoContainer} >
          <img src={logo} alt="ReynaCare"  style={{
         
          }}/>
        </div>
      </Flex>
      <Flex gap="1rem" align="center" justify="center">
        {
          <Dropdown
            overlayClassName={
              notificationsList && notificationsList.length > 0
                ? styles.notificationDropDown
                : styles.noNotifcation
            }
            menu={{ items }}
            placement="bottom"
            trigger={["click"]}
          >
            <Badge count={notificationCount}>
              <Button
                icon={
                  <NotificationIcon
                    fillColor={colors.gunMetalGray}
                    width="20px"
                  />
                }
              />
            </Badge>
          </Dropdown>
        }
        <Flex gap="0.3rem" align="center">
          <Avatar
            src={userSession?.profileImage}
            size={45}
            shape="square"
            icon={<UserOutlined />}
          />

          <Button
            size="small"
            type="text"
            onClick={() => setDrawerOpen((prevValue) => !prevValue)}
            icon={<DownOutlined />}
          />
        </Flex>
      </Flex>
    </Layout.Header>
  );
};

export default Navbar;
